<template>
  <div>
    <!-- Page header -->
    <div class="flex items-center gap-3 px-4 pt-4">
      <span
        class="flex items-center justify-center w-10 h-10 rounded-xl bg-taxiye-100 text-taxiye-500"
      >
        <span class="material-icons-round">lock_reset</span>
      </span>
      <div>
        <h2 class="text-lg font-semibold text-gray-800">Reset Password</h2>
        <p class="text-sm text-red-600" v-if="invalid">
          {{ this.errorMessage }}
        </p>
        <p class="text-sm text-gray-500" v-else>
          Set a new password for this user.
        </p>
      </div>
    </div>

    <form @submit.prevent="resetPassword">
      <div
        class="p-6 m-4 bg-white border border-gray-200 shadow-sm max-w-2xl rounded-2xl"
      >
        <div class="grid grid-cols-1 gap-5 sm:grid-cols-2">
          <label class="block">
            <span class="text-sm font-medium text-gray-600">New Password</span>
            <input
              v-model="newPassword"
              :type="showPasswords ? 'text' : 'password'"
              class="block w-full mt-1 border-gray-300 shadow-sm form-input rounded-xl text-sm focus:border-taxiye-300"
              placeholder="New Password"
            />
          </label>
          <label class="block">
            <span class="text-sm font-medium text-gray-600"
              >Confirm Password</span
            >
            <input
              v-model="confirmPassword"
              :type="showPasswords ? 'text' : 'password'"
              class="block w-full mt-1 border-gray-300 shadow-sm form-input rounded-xl text-sm focus:border-taxiye-300"
              placeholder="Confirm password"
            />
          </label>
        </div>

        <div class="mt-4">
          <label
            class="inline-flex items-center text-sm text-gray-700 cursor-pointer"
          >
            <input
              type="checkbox"
              class="mr-2 rounded text-taxiye-500 focus:ring-taxiye-300"
              v-model="showPasswords"
            />Show Passwords</label
          >
        </div>

        <div
          class="flex items-center justify-between pt-5 mt-6 border-t border-gray-100"
        >
          <button
            type="button"
            @click="changePage('index')"
            class="inline-flex items-center h-10 px-4 text-sm font-medium text-gray-600 transition-colors rounded-xl hover:bg-gray-100"
          >
            <span class="mr-1 text-base material-icons-round">arrow_back</span>
            Back
          </button>
          <button
            :disabled="busy || invalid"
            class="inline-flex items-center justify-center h-10 px-6 text-sm font-semibold text-white transition-colors rounded-xl shadow-sm"
            :class="{
              'bg-taxiye-200 cursor-not-allowed': invalid || busy,
              'bg-taxiye-500 hover:bg-taxiye-600': !invalid && !busy,
            }"
          >
            Set New Password
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  props: ["account", "changePage"],
  data() {
    return {
      busy: false,
      newPassword: "",
      confirmPassword: "",
      startValidating: false,
      showPasswords: false,
    };
  },
  computed: {
    id() {
      return this.account ? this.account._id : "";
    },
    invalid() {
      return (
        this.newPassword.length < 8 || this.newPassword !== this.confirmPassword
      );
    },
    errorMessage() {
      if (this.startValidating) {
        if (this.newPassword.length < 8)
          return "password too short (< 8 chars.)";
        else if (this.newPassword !== this.confirmPassword)
          return "passwords don't match";
        return "";
      }
      return "";
    },
    validationTrigger() {
      return this.newPassword + this.confirmPassword;
    },
  },
  created() {},
  methods: {
    resetPassword() {
      this.busy = true;
      this.$misc
        .post(`accounts/${this.id}/reset-password`, {
          newPassword: this.newPassword,
        })
        .then(() => {
          window.flash({
            body: "Password set successfully!",
            type: "success",
          });
          this.changePage("index");
        })
        .catch(err => {
          window.flash({ body: "Failed to set new password!", type: "error" });
          console.log(err);
        })
        .finally(() => (this.busy = false));
    },
  },
  watch: {
    validationTrigger() {
      if (!this.startValidating) this.startValidating = true;
    },
  },
};
</script>
